import React, { Component } from 'react'
import { NavLink, Link, Redirect} from 'react-router-dom'
import logo from '../../assets/image/propaganda-logo-black.png'

import { connect } from 'react-redux'

class NavBar extends Component {
  render() {
    const { userStatus } = this.props
    
    if(userStatus.uid) return <Redirect to="/dashboard" />
    return (
       <header id="header" className="page-topbar">
       
        <div className="navbar-fixed">
            <nav className="navbar-color z-depth-0">
                <div className="nav-wrapper white z-depth-1 ">
                  <div className="left">                    
                      <span className="logo-wrapper"><Link to="/"  className="brand-logo darken-1"><img src={logo} alt="materialize logo"/></Link></span>
                  </div>
                  
                  <ul id="nav-mobile" className="right hide-on-small-only">
                      <li><NavLink className="black-text" to="/">Home</NavLink></li>
                      <li><NavLink  className="black-text"to="/simple-nice-list-mobile-phone-app">Nice List App</NavLink></li> 
                      <li><NavLink  className="black-text"to="/coin-flip-mobile-phone-app">Coin Flip App</NavLink></li> 
                  </ul>
                  
                </div> 
              </nav>
        </div>
       
        </header>
   
    )
  }
}
const mapStateToProps = (state) => {
  return {
      userStatus: state.firebase.auth,
  }
}
export default connect(mapStateToProps, null )(NavBar)
